import { render, staticRenderFns } from "./CLCNewsDetail.vue?vue&type=template&id=324f147c"
import script from "./CLCNewsDetail.vue?vue&type=script&lang=js"
export * from "./CLCNewsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports